var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGenerator = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.755 2C7.258 2 6.041 3.233 6.041 4.75v15.125h16.286V4.75c0-1.517-1.217-2.75-2.714-2.75H8.755zm1.018 2.75c.364 0 .7.197.882.516.182.319.182.712 0 1.03-.182.32-.518.516-.882.516a1.025 1.025 0 0 1-1.018-1.03c0-.57.456-1.032 1.018-1.032zm7.804 1.031c0-.57.456-1.031 1.018-1.031s1.018.462 1.018 1.031c0 .57-.456 1.032-1.018 1.032a1.025 1.025 0 0 1-1.018-1.032zM6.04 21.25c-.75 0-1.357.614-1.357 1.375 0 .76.607 1.375 1.357 1.375h16.286c.75 0 1.357-.614 1.357-1.375 0-.76-.606-1.375-1.357-1.375H6.04z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGenerator, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/generator.92c23615.svg";
export { ForwardRef as ReactComponent };